export default "__VITE_ASSET__DsyCg94B__"